var _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinesweeperLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 58,
    viewBox: "0 0 74 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 29,
    r: 15,
    fill: "url(#paint0_linear_33_96)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 15.5,
    x2: 42.5,
    y2: 10.5,
    stroke: "#58008E",
    strokeOpacity: 0.996875,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 54.3487,
    y1: 20.9075,
    x2: 58.9075,
    y2: 17.6513,
    stroke: "#58008E",
    strokeOpacity: 0.996875,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30.9075,
    y1: 20.3487,
    x2: 26.3487,
    y2: 17.0925,
    stroke: "#58008E",
    strokeOpacity: 0.996875,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 27.6976,
    y1: 30.6745,
    x2: 22.6745,
    y2: 31.3024,
    stroke: "#58008E",
    strokeOpacity: 0.996875,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 33.1627,
    y1: 39.1151,
    x2: 29.1151,
    y2: 43.8373,
    stroke: "#58008E",
    strokeOpacity: 0.996875,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 44.8974,
    y1: 39.9487,
    x2: 46.9487,
    y2: 46.1026,
    stroke: "#58008E",
    strokeOpacity: 0.996875,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 55.0125,
    y1: 35.3292,
    x2: 60.3292,
    y2: 37.9875,
    stroke: "#58008E",
    strokeOpacity: 0.996875,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_96",
    x1: 37,
    y1: 17.5,
    x2: 55,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7803BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268543,
    stopColor: "#58008E",
    stopOpacity: 0.996875
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58008E",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinesweeperLogo);
export default __webpack_public_path__ + "static/media/minesweeper-logo.7a37b8476d8f0eb2755893e3e07a7fbb.svg";
export { ForwardRef as ReactComponent };